export enum CustomColumnScope {
  FINDING = 'FINDING',
  PRODUCT = 'PRODUCT',
  SUB_PRODUCT = 'SUB_PRODUCT',
  ASSETS = 'ASSETS',
  DISCOVERY = 'DISCOVERY',
  ASSESSMENT = 'ASSESSMENT',
}
export type CustomFindingColumn = {
  columnName: string;
  key: string;
  scope: CustomColumnScope[];
};

export type CustomFindingColumnsConfig = {
  tags: CustomFindingColumn[];
};

export type ProductSubproductTagIdentifier = {
  tagKeys: string[];
};

export type KeyValue = { key: string; value?: string };

export type ReportsConfig = {
  footerMessage?: string;
  logoFileName?: string;
  logoUrl?: string;
};

export enum RiskAssessmentTypes {
  'Text-Short' = 'Text-Short',
  'Text-Long' = 'Text-Long',
  'Date' = 'Date',
  'Single-Select' = 'Single-Select',
  'Multi-Select' = 'Multi-Select',
}

export interface ArmorcodeCustomField {
  type: RiskAssessmentTypes;
  label: string;
  required?: boolean;
  values?: string[];
  id: string;
}

export type FindingCustomField = {
  label: string;
  required?: boolean;
  values?: string[];
  id: string;
  type: string;
  findingAttribute?: string;
  format?: string;
  sync?: boolean;
};

export interface ExtendedFindingCustomField extends FindingCustomField {
  unsaved?: boolean;
}
export interface DerivedAttribute {
  columnName: string;
  columnValue: string;
  id: string;
  regex: string;
  sourceAttribute: string;
  sourceAttributeDisplayName: string;
}

export enum PROPOSE_TYPE {
  PROPOSE_FALSE_POSITIVE = 'PROPOSE_FALSE_POSITIVE',
  PROPOSE_SUPPRESSED = 'PROPOSE_SUPPRESSED',
  PROPOSE_TRIAGE = 'PROPOSE_TRIAGE',
  PROPOSE_IN_PROGRESS = 'PROPOSE_IN_PROGRESS',
  PROPOSE_MITIGATED = 'PROPOSE_MITIGATED',
  PROPOSE_CATEGORY = 'PROPOSE_CATEGORY',
}

export interface ProposeCustomField {
  key: PROPOSE_TYPE;
  enabled: boolean;
  customFields: string[];
}
export interface AssetScoreTag {
  name: string;
  fieldValue: string;
  value: number;
  field?: string;
  exactValue?: boolean;
}
export interface FindingColumnManagementConfig {
  overrideDefaults: boolean;
  defaultColumnKeys: string[];
  forceUpdateTimeStamp: number | null;
  hideColumns: boolean;
  hiddenColumnKeys: string[];
}
export interface ColumnOption {
  key: string;
  label: string;
  disabled?: boolean;
}

export enum AppMenuItemInbuiltType {
  DASHBOARD = 'DASHBOARD',
  INSIGHTS = 'INSIGHTS',
  COMPLIANCE = 'COMPLIANCE',
  REPO_SUMMARY = 'REPO_SUMMARY',
  FINDINGS = 'FINDINGS',
  HIERARCHY = 'HIERARCHY',
  PRODUCT = 'PRODUCT',
  SUBPRODUCT = 'SUBPRODUCT',
  SCANS = 'SCANS',
  SBOM = 'SBOM',
  TICKETS = 'TICKETS',
  PROJECT = 'PROJECT',
  EXCEPTION = 'EXCEPTION',
  ASSESSMENT = 'ASSESSMENT',
  DISCOVERY = 'DISCOVERY',
  ASSET = 'ASSET',
  FEED = 'FEED',
  AI_APPROVAL = 'AI_APPROVAL',
  AI_INVENTORY = 'AI_INVENTORY',
  AI_CATALOG = 'AI_CATALOG',
  AI_USERS = 'AI_USERS',
  AI_EXPOSURES = 'AI_EXPOSURES',
  AGENTIC_ASSET = 'AGENTIC_ASSET',
  SECURITY_TOOLS = 'SECURITY_TOOLS',
  INTEGRATIONS = 'INTEGRATIONS',
  AUTOMATION = 'AUTOMATION',
  SCHEDULED_REPORTS = 'SCHEDULED_REPORTS',
  COMPLIANCE_POLICIES = 'COMPLIANCE_POLICIES',
  AUDIT_LOG = 'AUDIT_LOG',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  GLOBALSETTINGS = 'GLOBALSETTINGS',
}

export type AppMenuItemCustom = {
  to: string;
  label: string;
  id: string;
  labelString?: string;
};

export type AppMenuItemInbuilt = {
  type: AppMenuItemInbuiltType;
};

export type AppMenuItem = AppMenuItemCustom | AppMenuItemInbuilt;

export type AppMenuSection = {
  name: string;
  icon: string;
  items?: AppMenuItem[];
};

export type AppNavConfig = {
  enabled?: boolean;
  sections: AppMenuSection[];
  customItems?: AppMenuItem[];
};

/**
 * ENG-133432 / ENG-133433 — CRG crown-jewel tag rules.
 *
 * A single tag condition (key = value). Both are required, non-blank, and are
 * compared case-insensitively as whole strings by the CRG attack bot.
 */
export interface CrownJewelTagCondition {
  tagKey: string;
  tagValue: string;
}

/**
 * A rule is 1-3 tag conditions that must ALL match (AND). Rules OR together:
 * an asset that matches ANY rule is treated as a crown jewel.
 */
export interface CrownJewelTagRule {
  tags: CrownJewelTagCondition[];
}

/**
 * Config blob stored under tenant-config type CRG_CROWN_JEWEL_TAG_RULES.
 * The wrapper object leaves room for a future `arns` key (backend design §3).
 */
export interface CrownJewelTagRulesConfig {
  tagRules: CrownJewelTagRule[];
}

export interface AVIConfig {
  enabled: boolean;
  providers: string[];
}
